import React, { useRef } from "react";
import copy from "copy-to-clipboard";
import TooltipedComp, { TooltipPosition } from "../TooltipedComp";

interface CopyURLToClipboardBtnProps {
  url?: string;
  size?: "default" | "large";
  color?: "purple" | "white";
  tooltipPosition?: string;
}

function CopyURLToClipboardBtn({
  url,
  size = "default",
  color = "purple",
  tooltipPosition = TooltipPosition.BOTTOM_LEFT,
}: CopyURLToClipboardBtnProps) {
  const tooltipText = "URL added to clipboard!";
  const tooltipRef = useRef<{ displayTooltip: () => void }>(null);

  const copyLinkToClipboard = () => {
    if (url) {
      copy(url);
    } else {
      copy(window.location.href);
    }
    if (tooltipRef.current) {
      tooltipRef.current.displayTooltip();
    }
  };

  return (
    <TooltipedComp
      ref={tooltipRef}
      tooltip={tooltipText}
      position={tooltipPosition}
    >
      <button
        type="button"
        onClick={() => copyLinkToClipboard()}
        className={`${
          color === "purple" ? "hover:bg-purple" : "hover:bg-white"
        } hover:rounded-full`}
      >
        <img
          src={`${
            color === "purple"
              ? "/icons/Quest/share.svg"
              : "/icons/Quest/share-white.svg"
          }`}
          className={`hover:brightness-0 ${size === "large" ? "h-12" : ""}`}
          alt="share"
        />
      </button>
    </TooltipedComp>
  );
}

export default CopyURLToClipboardBtn;
